import { servicePath, type ServiceRoute } from '@vnetwork/margarita-shell/service-route';
import type { WaapHost } from './host';
import { waapPaths } from './paths';

/**
 * Plain data + lazy loaders: do not import the console here (it would join the entry chunk).
 * The host is lazy too: each `load` resolves it and registers it before the console's chunk is even
 * requested, so no hook of the module can run before the host exists. `host.ts` is imported here,
 * not at the top, so it stays out of the entry chunk too. The promise is kept, so a second
 * navigation (or a prefetch) does not resolve it again; a failure is not kept.
 *
 * Promise chains, not `async`/`await`: this file is in the entry chunk and the build transpiles
 * `async` into a generator state machine and array destructuring into helpers.
 */
export function createWaapRoutes(loadHost: () => Promise<WaapHost>): ServiceRoute[] {
  let hostReady: Promise<void> | undefined;
  const ready = () => {
    if (!hostReady) {
      hostReady = loadHost()
        .then((host) => import('./host').then((m) => m.registerWaapHost(host)))
        .catch((e) => {
          hostReady = undefined; // a failed chunk fetch must be retryable
          throw e;
        });
    }
    return hostReady;
  };
  return [
    { path: servicePath(waapPaths.base), load: () => ready().then(() => import('./WaapLandingGate')).then((m) => ({ default: m.WaapLandingGate })) },
    { path: servicePath(waapPaths.onboarding), load: () => ready().then(() => import('./WaapOnboardingLauncher')).then((m) => ({ default: m.WaapOnboardingLauncher })) },
    { path: servicePath(waapPaths.base, ':serviceId/*'), load: () => ready().then(() => import('./index')).then((m) => ({ default: m.WaapConsole })) },
  ];
}
